export const TAB_PASSPORTS = 'passports';
export const tabOptions = [{ value: TAB_PASSPORTS, label: 'Passports' }];
